// extracted by mini-css-extract-plugin
export default {"TextInput":"FilesSearchBox-module__TextInput--o9VJM","Box":"FilesSearchBox-module__Box--_nCUu"};